export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
  case 'SET_DAMAGE_OPT_IN_STATUS':
    return {
      ...state,
      damageProtection: payload
    };
  case 'SET_PICKUP_DATE':
    return {
      ...state,
      reservation: {
        ...state.reservation,
        pickupDate: payload
      }
    };
  case 'SET_DROPOFF_DATE':
    return {
      ...state,
      reservation: {
        ...state.reservation,
        dropoffDate: payload
      }
    };
  case 'SET_PICKUP_TIME':
    return {
      ...state,
      reservation: {
        ...state.reservation,
        pickupTime: payload
      }
    };
  case 'SET_DROPOFF_TIME':
    return {
      ...state,
      reservation: {
        ...state.reservation,
        dropoffTime: payload
      }
    };

  case 'SET_ACTIVE_SECTION':
    return {
      ...state,
      activeSection: payload
    };
  case 'SET_RESERVATION_STORE':
    return {
      ...state,
      selectedStore: payload,
      editStore: false,
      selectedStoreAvailability: true
    };
  case 'SET_AVAILABILITY_OPTION':
    return {
      ...state,
      selectedAvailability: payload
    };
  case 'SET_VALID_TIME_OPTION':
    return {
      ...state,
      validTimeOption: payload
    };
  case 'SET_TIME_ERROR_MESSAGE':
    return {
      ...state,
      timeErrorMessage: payload
    };
  case 'SET_RENTAL_CONTRACT_TERMS':
    return {
      ...state,
      contractTerms: payload
    };
  case 'SET_NEARBY_WHITELISTED_STORES':
    return {
      ...state,
      nearbyWhitelistedStoresList: payload
    };
  case 'SET_RESERVATION_MODIFY_STORE':
    return {
      ...state,
      reservationModifyStore: payload
    };
  case 'SET_EDIT_STORE':
    return {
      ...state,
      selectedStore: {},
      editStore: true
    };
  case 'SET_API_RESULT':
    return {
      ...state,
      ...payload
    };
  case 'SET_AVAILABLE_NEARBY':
    return {
      ...state,
      availableNearby: payload
    };
  default:
    return state;
  }
};
